import logging from "web/script/utils/logging";

if (typeof btoa == "undefined") {
    global.btoa = require("btoa"); // eslint-disable-line no-undef
}

/**
 * Jinja filter that converts an object to a JSON representation,
 * then converts it again into a base64 string. Returns a 'null' string
 * if something goes wrong during the conversion.
 *
 * @params {Object}
 * @returns {String}
 */
export function base64Json(obj) {
    if (obj === undefined) {
        return "null";
    }

    try {
        const jsonString = JSON.stringify(obj);

        // We need to encode unicode characters as btoa can't handle them
        const encodedString = jsonString
            .split("")
            .map((x) =>
                x.codePointAt(0) >= 256
                    ? "\\u" + ("000" + x.codePointAt(0).toString(16)).substr(-4)
                    : x
            )
            .join("");

        return btoa(encodedString);
    } catch (e) {
        logging.error(e);

        return "null";
    }
}

/**
 * Utility function that translates base64 strings into JSON objects.
 *
 * @params {String}
 * @returns {Object}
 */
export function base64toJson(base64) {
    const jsonString = atob(base64);

    try {
        return JSON.parse(jsonString);
    } catch (e) {
        logging.error(e);

        return null;
    }
}

/**
 * Utility function to return the mark up to use for icon
 *
 * @param name {String} Name of icon to use
 * @returns {String}
 */
export function svgIcon(name) {
    return `
        <svg class="svg-icon svg-icon-${name}">
            <use xlink:href="#${name}"></use>
        </svg>
    `;
}

/**
 * Utility function to install new filters into the Jinja-to-JS runtime.
 *
 * @params {Object} jinjaToJs
 */
export function installJinjaFilters(jinjaToJs) {
    jinjaToJs.filters.base64_json = base64Json;
    jinjaToJs.filters.svg_icon = svgIcon;
}
